import { Component, OnDestroy, OnInit, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ListasService } from '../../../services/listas.service';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { ClaseSolicitudDto } from '../../../dto/expediente/clase-solicitud-dto.dto';
import { Constants } from '../../../constants/constants';
import { PersonaDTO } from '../../../dto/expediente/persona.dto';
import { TramiteDndaService } from '../../../services/tramite-dnda.service';
import { ArchivosFormDTO } from '../../../dto/expediente/archivos-form.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TipoPersonaDto } from '../../../dto/expediente/tipo-persona-dto.dto';
import { PaisDto } from '../../../dto/expediente/pais.dto';
import { PersonaLoginDTO } from '../../../dto/util/persona.dto';
import { PersonaDto } from '../../../dto/tramites/persona.dto';
import { TramiteDndaDto } from '../../../dto/tramites/tramite-dnda.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { TramiteService } from '../../../services/tramite.service';
import { TramiteDTO } from '../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { Location } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TextTransformService } from '../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../util/modal-datos/services/datos-adicionales.service';
import { DemandadoAuxDto } from '../../../dto/tramites/demandado-aux.dto';
import { LanguageService } from '../../../services/util/language.service';
import { PersonaComponent } from '../persona/persona.component';

@Component({
  selector: 'app-creacion-dnda',
  templateUrl: './creacion-dnda.component.html',
  styleUrl: './creacion-dnda.component.scss',
})
export class CreacionDndaComponent implements OnInit, OnDestroy {
  idiomaActual: string = 'es';
  visualizarComponenteArchivos: boolean = false;
  tramite: any;
  expediente: FormGroup = new FormGroup({});
  selectedOptions = '';
  countries: PaisDto[] = [];
  listaClaseSolicitud: ClaseSolicitudDto[] = [];
  documentTypeList: TipoDocumentoDto[] = [];
  documentTypeListApoderado: TipoDocumentoDto[] = [];
  documentTypeLegalList: TipoDocumentoDto[] = [];
  documentTypeListJuridico: TipoDocumentoDto[] = [];
  opcionesApoderado: any[] = [
    { value: true, text: 'Si' },
    { value: false, text: 'No' },
  ];
  claseSolicitudDemanda = false
  esPersonaNaturalDemandante = true;
  listaTipoPersona: TipoPersonaDto[] = [];
  entidadId = Constants.ID_ENTIDAD_DNDA;
  actuarConApoderado = false;
  claseSolicitud = 0;
  demandId: number = Constants.DEMAND_REQUEST_CLASS_ID;
  demandadoAux: DemandadoAuxDto = {};
  formDemanding: { valid: boolean; data: PersonaDTO } = {
    valid: false,
    data: {
      email: '',
      primerNombre: '',
      primerApellido: '',
      tipoDocumento: '',
      identificacion: '',
      pais: '',
      departmento: '',
      municipio: '',
      otroDepartamento: '',
      otroMunicipio: '',
      direccion: '',
    },
  };
  formRepresentative: { valid: boolean; data: PersonaDTO } = {
    valid: false,
    data: {
      email: '',
      primerNombre: '',
      primerApellido: '',
      tipoDocumento: '',
      identificacion: '',
      pais: '',
      departmento: '',
      municipio: '',
      otroDepartamento: '',
      otroMunicipio: '',
      direccion: '',
      tarjetaProfesional: '',
    },
  };
  formDefendant: { valid: boolean; data: PersonaDTO } = {
    valid: false,
    data: {
      email: '',
      primerNombre: '',
      primerApellido: '',
      tipoDocumento: '',
      identificacion: '',
      pais: '',
      departmento: '',
      municipio: '',
      otroDepartamento: '',
      otroMunicipio: '',
      direccion: '',
    },
  };
  formRepresentanteLegal: { valid: boolean; data: PersonaDTO } = {
    valid: false,
    data: {
      email: '',
      primerNombre: '',
      primerApellido: '',
      tipoDocumento: '',
      identificacion: '',
      pais: '',
      departmento: '',
      municipio: '',
      otroDepartamento: '',
      otroMunicipio: '',
      direccion: '',
    },
  };

  dataUsuario: PersonaLoginDTO | undefined;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Objetos para guardar los datos del trámite existente
  dataApoderado = {};
  dataDemandante = {};
  dataDemandado = {};
  dataRepresentante = {};
  idTramite!: number | null;

  // ID persona
  idApoderado!: number;
  idDemandado!: number;
  idDemandante!: number;
  idRepresentante!: number;
  archivosCargados: AnexoPrecargaResponseDto[] = [];

  // Multilenguaje
  dndaText: any = {};
  comunText: any = {};
  alertaText: any = {};
  confirmacionEnvio: boolean = false;
  proceso: string = '';
  entidad: string = '';
  tituloConDatos: string = '';

  @ViewChildren(PersonaComponent) personaComponentes!: QueryList<PersonaComponent>;

  constructor(
    private readonly fb: FormBuilder,
    private readonly listService: ListasService,
    private readonly router: Router,
    private readonly tramiteDndaService: TramiteDndaService,
    private readonly alertaModalService: AlertaModalService,
    private readonly utilService: UtilService,
    private readonly tramiteService: TramiteService,
    private languageService: LanguageService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService
  ) { }

  buildForm() {
    this.expediente = this.fb.group({
      requestClass: ['', Validators.required],
      actuarConApoderado: ['', Validators.required],
      numeroTarjetaProfesional: [
        '',
        [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
      ],
      telefonoApoderado: [
        '',
        [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(/^\d+$/),
        ],
      ],
      tipoAnexo: ['', [Validators.required]],
      archivos: ['', [Validators.required]],
    });
  }
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;

  ngOnInit() {
    this.loadListCountries();
    this.loadDocumentTypeList();
    this.loadListaClaseSolicitud();
    this.loadListKindOfPerson();
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    this.tramiteService.obtenerNombreEntidadPorId(5).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Consultar si existe un trámite pendiente
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        Constants.DNDA_OBTVEG
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.consultarTramitePorID(resp.Id);
              this.dataUsuario = undefined;
            },
            () => {
              this.visualizarComponenteArchivos = true;
              this.idTramite = null;
              this.dataUsuario = JSON.parse(
                sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
              );
            },
            true
          );
        } else {
          this.visualizarComponenteArchivos = true;
          this.idTramite = null;
          this.dataUsuario = JSON.parse(
            sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
          );
        }
      });

    this.buildForm();
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    this.actuarConApoderado = user_type.Nombre === 'Abogado';
    if (this.actuarConApoderado) {
      this.expediente.get('actuarConApoderado')?.setValue('true');
      this.dataUsuario = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      );
      this.getDataUsuario(this.dataUsuario?.idPersona!);
    }
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de violación al derecho de autor en la entidad Dirección Nacional ' +
        'de Derechos de Autor',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de violación al derecho de autor en la ' +
        'Dirección Nacional de Derechos de Autor',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.dndaText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
  }

  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.onSubmitSave();
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }
  ngOnDestroy() {
    // Evento de recargar o cerrar pestaña
    // window.removeEventListener('beforeunload', this.unloadNotification);
  }

  // Se consume el servicio de consultar el detalle del trámite según el ID
  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          if (resp.claseSolicitud.id === Constants.DEMAND_REQUEST_CLASS_ID) {
            this.claseSolicitudDemanda = true;
          } else {
            this.confirmacionEnvio = true;
            this.seleccionAceptoRechazoEnvio = true;
            this.enviarCorreoDemandado = false;
            this.claseSolicitudDemanda = false;
          }
          if (resp.anexos) {
            this.archivosCargados = resp.anexos;
          }
          if (typeof resp.tieneApoderado == 'string') {
            this.actuarConApoderado = resp.tieneApoderado == 'Si' ? true : false;
          } else {
            this.actuarConApoderado = resp.tieneApoderado;
          }
          this.actuarConApoderado
            ? this.expediente.controls['actuarConApoderado'].setValue(true)
            : this.expediente.controls['actuarConApoderado'].setValue(false);

          if (resp.claseSolicitud) {
            this.expediente.controls['requestClass'].setValue(
              resp.claseSolicitud.id
            );
            this.claseSolicitud = resp.claseSolicitud.id;
          }

          if (resp.apoderado?.id) {
            this.idApoderado = resp.apoderado.id;
            resp.apoderado.telefonoPrincipal
              ? this.expediente.controls['telefonoApoderado'].setValue(
                resp.apoderado.telefonoPrincipal
              )
              : null;
            resp.apoderado.tarjetaProfesional
              ? this.expediente.controls['numeroTarjetaProfesional'].setValue(
                resp.apoderado.tarjetaProfesional
              )
              : null;
            resp.apoderado = this.textTransformService.transformarAMayusculas(
              resp.apoderado
            );
            this.dataApoderado = {
              tipoDePersona: resp.apoderado.idTipoPersona
                ? resp.apoderado.idTipoPersona
                : null,
              email: resp.apoderado.correoElectronico
                ? resp.apoderado.correoElectronico
                : null,
              primerNombre: resp.apoderado.primerNombre
                ? resp.apoderado.primerNombre
                : null,
              segundoNombre: resp.apoderado.segundoNombre
                ? resp.apoderado.segundoNombre
                : null,
              primerApellido: resp.apoderado.primerApellido
                ? resp.apoderado.primerApellido
                : null,
              segundoApellido: resp.apoderado.segundoApellido
                ? resp.apoderado.segundoApellido
                : null,
              tipoDocumento: resp.apoderado.idTipoIdentificacion
                ? resp.apoderado.idTipoIdentificacion
                : null,
              identificacion: resp.apoderado.identificacion
                ? resp.apoderado.identificacion
                : null,
              pais: resp.apoderado.municipio.idPais
                ? resp.apoderado.municipio.idPais
                : null,
              departmento: resp.apoderado.municipio.idDepartamento
                ? resp.apoderado.municipio.idDepartamento
                : null,
              municipio: resp.apoderado.municipio.id
                ? resp.apoderado.municipio.id
                : null,
              otroDepartamento: resp.apoderado.otroDepartamento
                ? resp.apoderado.otroDepartamento
                : null,
              otroMunicipio: resp.apoderado.otroMunicipio
                ? resp.apoderado.otroMunicipio
                : null,
              direccion:
                resp.apoderado.direccionPersona &&
                  resp.apoderado.direccionPersona.length > 0
                  ? resp.apoderado.direccionPersona[0].direccionNotificacion
                  : null,
            };
          }

          if (resp.demandado.length > 0) {
            this.idDemandado = resp.demandado[0].id;
            resp.demandado[0] =
              this.textTransformService.transformarAMayusculas(
                resp.demandado[0]
              );
            this.dataDemandado = {
              tipoDePersona: resp.demandado[0].idTipoPersona
                ? resp.demandado[0].idTipoPersona
                : null,
              email: resp.demandado[0].correoElectronico
                ? resp.demandado[0].correoElectronico
                : null,
              primerNombre: resp.demandado[0].primerNombre
                ? resp.demandado[0].primerNombre
                : resp.demandado[0].razonSocial,
              segundoNombre: resp.demandado[0].segundoNombre
                ? resp.demandado[0].segundoNombre
                : null,
              primerApellido: resp.demandado[0].primerApellido
                ? resp.demandado[0].primerApellido
                : null,
              segundoApellido: resp.demandado[0].segundoApellido
                ? resp.demandado[0].segundoApellido
                : null,
              tipoDocumento: resp.demandado[0].idTipoIdentificacion
                ? resp.demandado[0].idTipoIdentificacion
                : null,
              identificacion: resp.demandado[0].identificacion
                ? resp.demandado[0].identificacion
                : null,
              pais: resp.demandado[0].municipio.idPais
                ? resp.demandado[0].municipio.idPais
                : null,
              departmento: resp.demandado[0].municipio.idDepartamento
                ? resp.demandado[0].municipio.idDepartamento
                : null,
              municipio: resp.demandado[0].municipio.id
                ? resp.demandado[0].municipio.id
                : null,
              otroDepartamento: resp.demandado[0].otroDepartamento
                ? resp.demandado[0].otroDepartamento
                : null,
              otroMunicipio: resp.demandado[0].otroMunicipio
                ? resp.demandado[0].otroMunicipio
                : null,
              direccion: resp.demandado[0].direccionPersona[0]
                ?.direccionNotificacion
                ? resp.demandado[0].direccionPersona[0]?.direccionNotificacion
                : null,
            };
          }

          if (resp.demandante.length > 0) {
            this.idDemandante = resp.demandante[0].id;
            resp.demandante[0] =
              this.textTransformService.transformarAMayusculas(
                resp.demandante[0]
              );
            this.dataDemandante = {
              tipoDePersona: resp.demandante[0].idTipoPersona
                ? resp.demandante[0].idTipoPersona
                : null,
              email: resp.demandante[0].correoElectronico
                ? resp.demandante[0].correoElectronico
                : null,
              primerNombre: resp.demandante[0].primerNombre
                ? resp.demandante[0].primerNombre
                : resp.demandante[0]?.razonSocial,
              segundoNombre: resp.demandante[0].segundoNombre
                ? resp.demandante[0].segundoNombre
                : null,
              primerApellido: resp.demandante[0].primerApellido
                ? resp.demandante[0].primerApellido
                : null,
              segundoApellido: resp.demandante[0].segundoApellido
                ? resp.demandante[0].segundoApellido
                : null,
              tipoDocumento: resp.demandante[0].idTipoIdentificacion
                ? resp.demandante[0].idTipoIdentificacion
                : null,
              identificacion: resp.demandante[0].identificacion
                ? resp.demandante[0].identificacion
                : null,
              pais: resp.demandante[0].municipio.idPais
                ? resp.demandante[0].municipio.idPais
                : null,
              departmento: resp.demandante[0].municipio.idDepartamento
                ? resp.demandante[0].municipio.idDepartamento
                : null,
              municipio: resp.demandante[0].municipio.id
                ? resp.demandante[0].municipio.id
                : null,
              otroDepartamento: resp.demandante[0].otroDepartamento
                ? resp.demandante[0].otroDepartamento
                : null,
              otroMunicipio: resp.demandante[0].otroMunicipio
                ? resp.demandante[0].otroMunicipio
                : null,
              direccion: resp.demandante[0].direccionPersona[0]
                .direccionNotificacion
                ? resp.demandante[0].direccionPersona[0].direccionNotificacion
                : null,
            };

            if (resp.demandante[0].idTipoPersona === 2) {
              const representante =
                this.textTransformService.transformarAMayusculas(
                  resp.demandante[0].datosRepresentanteLegal
                );
              this.dataRepresentante = {
                email: representante.correoElectronico
                  ? representante.correoElectronico
                  : null,
                primerNombre: representante.primerNombre
                  ? representante.primerNombre
                  : null,
                segundoNombre: representante.segundoNombre
                  ? representante.segundoNombre
                  : null,
                primerApellido: representante.primerApellido
                  ? representante.primerApellido
                  : null,
                segundoApellido: representante.segundoApellido
                  ? representante.segundoApellido
                  : null,
                tipoDocumento: representante.idTipoIdentificacion
                  ? representante.idTipoIdentificacion
                  : null,
                identificacion: representante.identificacion
                  ? representante.identificacion
                  : null,
                pais: representante.municipio.idPais
                  ? representante.municipio.idPais
                  : null,
                departmento: representante.municipio.idDepartamento
                  ? representante.municipio.idDepartamento
                  : null,
                municipio: representante.municipio.id
                  ? representante.municipio.id
                  : null,
                otroDepartamento: representante.otroDepartamento
                  ? representante.otroDepartamento
                  : null,
                otroMunicipio: representante.otroMunicipio
                  ? representante.otroMunicipio
                  : null,
                direccion: resp.demandante[0]?.datosRepresentanteLegal
                  .direccionPersona[0]?.direccionNotificacion
                  ? representante.direccionPersona[0].direccionNotificacion
                  : null,
              };
            }
          }
          this.visualizarComponenteArchivos = true;
        }
      });
  }

  loadListCountries() {
    this.listService.getCountryList().subscribe(countries => {
      this.countries = countries;
    });
  }

  async getMunicipioCountrie(idPais: number): Promise<number> {
    if (idPais != 0) {
      try {
        const countries = await firstValueFrom(
          this.listService.getDepartmentList(idPais)
        );
        const municipalities = await firstValueFrom(
          this.listService.getMunicipalityList(countries[0].Id)
        );
        return municipalities[0].Id;
      } catch (error) {
        console.error('Error al obtener el municipio:', error);
        return 0;
      }
    }
    return 0;

  }

  loadDocumentTypeList() {
    this.listService
      .getDocumentTypeListByPersonType('1', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeList = documentTypeList;
      });
    this.listService
      .getDocumentTypeListByPersonType('1', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeLegalList = documentTypeList;
      });
    this.listService
      .getDocumentTypeListByPersonType('1', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeListApoderado = documentTypeList.filter(
          documento => documento.Id !== 5
        );
      });
    this.listService
      .getDocumentTypeListByPersonType('2', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeListJuridico = documentTypeList;
      });
  }

  loadListaClaseSolicitud() {
    this.listService.getRequestClassList().subscribe(requestClass => {
      this.listaClaseSolicitud = requestClass;
    });
  }

  loadListKindOfPerson() {
    this.listService.getTipoDePersonaList().subscribe(kindOfPersonList => {
      this.listaTipoPersona = kindOfPersonList;
    });
  }

  handleFormDataDemandante(event: any) {
    this.formDemanding = event;
    if (event.data?.tipoDePersona) {
      this.esPersonaNaturalDemandante =
        event.data.tipoDePersona == Constants.TYPE_OF_PERSON_NATURAL;
    }
    this.formDemanding.valid = this.validarFormDemanding(event);
  }

  handleFormDataApoderado(event: any) {
    this.formRepresentative = event;
  }

  handleFormDataDemandado(event: any) {
    this.formDefendant = event;
    this.demandadoAux = event.data;
    this.formDefendant.valid = this.validarFormDefendant(event);
  }

  validarFormDefendant(event: any) {
    const tipoPersona = +event.data.tipoDePersona;
    const pais = +event.data.pais;

    const requiredFieldsForType2 = [
      'direccion',
      'email',
      'identificacion',
      'pais',
      'primerNombre',
      'tipoDePersona',
      'tipoDocumento',
    ];

    const requiredFieldsForType1 = [
      'direccion',
      'email',
      'identificacion',
      'pais',
      'primerApellido',
      'primerNombre',
      'tipoDePersona',
      'tipoDocumento',
    ];

    // Selecciona la lista base según el tipo de persona
    let fieldsToValidate =
      tipoPersona === Constants.TIPO_PERSONA.JURIDICA
        ? requiredFieldsForType2
        : requiredFieldsForType1;

    // Si el país es "1", se agregan `departmento` y `municipio` como obligatorios
    if (pais === Constants.ID_COLOMBIA) {
      fieldsToValidate = [...fieldsToValidate, 'departmento', 'municipio'];
    } else {
      fieldsToValidate = [...fieldsToValidate, 'otroDepartamento', 'otroMunicipio'];
    }

    // Verifica que todos los campos requeridos estén presentes y no vacíos
    const areRequiredFieldsValid = fieldsToValidate.every(
      field =>
        event.data[field] !== null &&
        event.data[field] !== undefined &&
        event.data[field].toString().trim() !== ''
    );

    event.valid = areRequiredFieldsValid && this.buildTempFormValidation(event);

    return event.valid;
  }

  // Demandante
  validarFormDemanding(event: any) {
    const tipoPersona = +event.data.tipoPersona;

    // Campos mínimos comunes
    const camposBasicos = ['email'];

    // Campos adicionales para persona natural
    const camposPersonaNatural = [
      'primerNombre',
      'primerApellido',
      'tipoDocumento',
      'identificacion',
      'pais',
      'direccion'
    ];

    // Campos adicionales para persona jurídica
    const camposPersonaJuridica = [
      'primerNombre',
      'tipoDocumento',
      'identificacion',
      'pais',
      'direccion'
    ];

    // Agregar ubicación
    const agregarCamposUbicacion =
      +event.data.pais === Constants.ID_COLOMBIA
        ? ['departmento', 'municipio']
        : ['otroDepartamento', 'otroMunicipio'];

    // Determinar campos a validar según tipoPersona
    let camposAValidar: string[];

    if (tipoPersona === Constants.TIPO_PERSONA.NATURAL) {
      camposAValidar = [
        ...camposBasicos,
        ...camposPersonaNatural,
        ...agregarCamposUbicacion,
      ];
    } else if (tipoPersona === Constants.TIPO_PERSONA.JURIDICA) {
      camposAValidar = [
        ...camposBasicos,
        ...camposPersonaJuridica,
        ...agregarCamposUbicacion,
      ];
    } else {
      camposAValidar = [];
    }

    // Validar que los campos requeridos estén presentes y no vacíos
    const sonCamposValidos = camposAValidar.every(
      field =>
        event.data[field] !== null &&
        event.data[field] !== undefined &&
        event.data[field].toString().trim() !== ''
    );

    event.valid = sonCamposValidos && this.buildTempFormValidation(event);

    return event.valid;
  }


  buildTempFormValidation(event: { valid: boolean; data: any }): boolean {
    const pais = +event.data.pais;
    const tipoPersona = +event.data.tipoDePersona;
    let patternIdentificacion: RegExp;
    if (tipoPersona === Constants.TIPO_PERSONA.NATURAL) {
      patternIdentificacion = event.data.tipoDocumento
        ? this.getPatternIdentificacion(event.data.tipoDocumento)
        : /.*/;

    } else if (tipoPersona === Constants.TIPO_PERSONA.JURIDICA) {
      patternIdentificacion = /^\d{4,9}$/;
    } else {
      patternIdentificacion = /.*/;
    }
    const tempForm: FormGroup = this.fb.group({
      tipoDePersona: [event.data.tipoDePersona ?? '', Validators.required],
      email: [
        event.data.email ?? '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
      ],
      tipoDocumento: [event.data.tipoDocumento ?? '', Validators.required],
      identificacion: [
        event.data.identificacion ?? '',
        [
          Validators.required,
          Validators.pattern(patternIdentificacion)
        ],
      ],
      pais: [event.data.pais ?? '', Validators.required],
      direccion: [
        event.data.direccion ?? '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS),
          Validators.minLength(10),
          Validators.maxLength(40),
        ],
      ],
    });

    // Reglas según tipo de persona
    if (tipoPersona === Constants.TIPO_PERSONA.JURIDICA) {
      // Persona jurídica: solo primerNombre es requerido
      tempForm.addControl(
        'primerNombre',
        this.fb.control(event.data.primerNombre ?? '', [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2),
        ])
      );

      tempForm.addControl(
        'primerApellido',
        this.fb.control(event.data.primerApellido ?? '', [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2),
        ])
      );
    } else {
      // Persona natural: primerNombre y primerApellido requeridos
      tempForm.addControl(
        'primerNombre',
        this.fb.control(event.data.primerNombre ?? '', [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2),
        ])
      );

      tempForm.addControl(
        'primerApellido',
        this.fb.control(event.data.primerApellido ?? '', [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2),
        ])
      );
    }

    // Otros nombres opcionales
    tempForm.addControl(
      'segundoNombre',
      this.fb.control(event.data.segundoNombre ?? '', [
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2),
      ])
    );

    tempForm.addControl(
      'segundoApellido',
      this.fb.control(event.data.segundoApellido ?? '', [
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2),
      ])
    );

    // Validaciones condicionales según país
    if (pais === Constants.ID_COLOMBIA) {
      tempForm.addControl('departmento', this.fb.control(event.data.departmento ?? '', Validators.required));
      tempForm.addControl('municipio', this.fb.control(event.data.municipio ?? '', Validators.required));
      tempForm.addControl('otroDepartamento', this.fb.control(event.data.otroDepartamento ?? ''));
      tempForm.addControl('otroMunicipio', this.fb.control(event.data.otroMunicipio ?? ''));
    } else {
      tempForm.addControl('departmento', this.fb.control(event.data.departmento ?? ''));
      tempForm.addControl('municipio', this.fb.control(event.data.municipio ?? ''));
      tempForm.addControl('otroDepartamento', this.fb.control(event.data.otroDepartamento ?? '', Validators.required));
      tempForm.addControl('otroMunicipio', this.fb.control(event.data.otroMunicipio ?? '', Validators.required));
    }

    // Ejecutar validación
    tempForm.markAllAsTouched();
    tempForm.updateValueAndValidity();

    event.valid = tempForm.valid;
    event.data = tempForm.getRawValue();

    return event.valid;
  }

  getPatternIdentificacion(tipoDocumentoId: number): RegExp {
    switch (tipoDocumentoId) {
      case 1:
      case 2:
        return /^\d{4,12}$/;
      case 3:
        return /^\d+$/;
      case 4:
        return /^[a-zA-Z0-9]{4,8}$/;
      case 5:
        return /^\d{4,9}$/;
      default:
        return /.*/;
    }
  }
  handleFormDataRepresentanteLegal(event: any) {
    this.formRepresentanteLegal = event;
  }

  onApoderadoChange(event: any) {
    this.actuarConApoderado = event.target.value === 'true';
  }

  onChangeRequestClass(event: any) {
    this.claseSolicitud = +event.target.value;
    if (+event.target.value === Constants.DEMAND_REQUEST_CLASS_ID) {
      this.claseSolicitudDemanda = true;
      this.confirmacionEnvio = false;
      this.seleccionAceptoRechazoEnvio = false;
    } else {
      this.confirmacionEnvio = true;
      this.seleccionAceptoRechazoEnvio = true;
      this.enviarCorreoDemandado = false;
      this.claseSolicitudDemanda = false;
    }
  }

  isButtonEnabled(): boolean {
    const requestClass: string = this.expediente.get('requestClass')?.value;
    if (+requestClass == Constants.DEMAND_REQUEST_CLASS_ID) {
      if (this.formDefendant.data.tipoDePersona) {
        this.formDefendant.valid = this.validarFormDefendant(
          this.formDefendant
        );
      }
      if (this.formDemanding.data.tipoDePersona) {
        this.formDemanding.valid = this.validarFormDemanding(
          this.formDemanding
        );
      }
      if (this.actuarConApoderado) {
        const esEnabled = (
          this.expediente.valid &&
          this.formDemanding.valid &&
          this.formRepresentative.valid &&
          this.formDefendant.valid &&
          (this.esPersonaNaturalDemandante
            ? true
            : this.formRepresentanteLegal.valid)
        );
        if (!esEnabled) {
          this.confirmacionEnvio = false;
        }
        return esEnabled;
      } else {
        if (this.formDefendant.data.tipoDePersona) {
          this.formDefendant.valid = this.validarFormDefendant(
            this.formDefendant
          );
        }
        if (this.formDemanding.data.tipoDePersona) {
          this.formDemanding.valid = this.validarFormDemanding(
            this.formDemanding
          );
        }
        const esEnabled = (
          this.expediente.valid &&
          this.formDemanding.valid &&
          this.formDefendant.valid &&
          (this.esPersonaNaturalDemandante
            ? true
            : this.formRepresentanteLegal.valid)
        );
        if (!esEnabled) {
          this.confirmacionEnvio = false;
        }
        return esEnabled;
      }
    } else {
      if (this.formDefendant.data.tipoDePersona) {
        this.formDefendant.valid = this.validarFormDefendant(
          this.formDefendant
        );
      }
      // this.formDemanding.valid = true;
      if (this.actuarConApoderado) {
        const esEnabled = (
          this.expediente.valid &&
          this.formDemanding.valid &&
          this.formRepresentative.valid &&
          (this.esPersonaNaturalDemandante || this.formRepresentanteLegal.valid)
        );
        if (!esEnabled) {
          //this.confirmacionEnvio = false;
        }
        return esEnabled;
      }
      const esEnabled = (
        this.expediente.valid &&
        this.formDemanding.valid &&
        (this.esPersonaNaturalDemandante
          ? true
          : this.formRepresentanteLegal.valid)
      );
      if (!esEnabled) {
        //this.confirmacionEnvio = false;
      }
      return esEnabled;
    }
  }

  setFilesFormValue(event: ArchivosFormDTO) {
    this.expediente.patchValue({
      archivos: event.Archivos,
      tipoAnexo: event.tipoAnexo,
    });
    const totalBytes = Array.from(event.Archivos).reduce(
      (acc: number, file: File) => acc + file.size,
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  private archivosValidos(): boolean {
    const archivos = this.expediente.get('archivos')?.value;
    return archivos && archivos.length > 0;
  }

  async onSubmit(): Promise<void> {

    if (!this.archivosValidos()) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }
    
    if (!this.isButtonEnabled()) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    if (!this.confirmacionEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['ley_2213']
      );
      return;
    }
    if (!this.seleccionAceptoRechazoEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['envio_demanda']
      );
      return;
    }
    const formData: FormData = new FormData();

    let id = 0;
    if (this.dataUsuario === undefined) {
      id = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      ).idUsuario;
    }
    const representante: PersonaDto = {
      id: this.idRepresentante ? this.idRepresentante : null,
      idTipoPersona: Number(this.formRepresentanteLegal.data.tipoDePersona),
      correoElectronico: this.formRepresentanteLegal.data.email,
      primerNombre: this.formRepresentanteLegal.data.primerNombre,
      segundoNombre: this.formRepresentanteLegal.data.segundoNombre,
      primerApellido: this.formRepresentanteLegal.data.primerApellido,
      segundoApellido: this.formRepresentanteLegal.data.segundoApellido,
      idTipoIdentificacion: Number(
        this.formRepresentanteLegal.data.tipoDocumento
      ),
      identificacion: this.formRepresentanteLegal.data.identificacion,
      municipio: { id: Number(this.formRepresentanteLegal.data.municipio) },
      otroDepartamento: this.formRepresentanteLegal.data.otroDepartamento,
      otroMunicipio: this.formRepresentanteLegal.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formRepresentanteLegal.data.direccion },
      ],
      razonSocial: this.formRepresentanteLegal.data.primerNombre,
    };

    const demandante: PersonaDto = {
      id: this.idDemandante ? this.idDemandante : null,
      idTipoPersona: Number(this.formDemanding.data.tipoDePersona),
      correoElectronico: this.formDemanding.data.email,
      primerNombre: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.primerNombre
        : undefined,
      segundoNombre: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.segundoNombre
        : undefined,
      primerApellido: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.primerApellido
        : undefined,
      segundoApellido: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.segundoApellido
        : undefined,
      idTipoIdentificacion: Number(this.formDemanding.data.tipoDocumento),
      identificacion: this.formDemanding.data.identificacion,
      municipio: {
        id:
          +this.formDemanding.data.pais == Constants.ID_COLOMBIA
            ? Number(this.formDemanding.data.municipio)
            : await this.getMunicipioCountrie(+this.formDemanding.data.pais),
      },
      otroDepartamento: this.formDemanding.data.otroDepartamento,
      otroMunicipio: this.formDemanding.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formDemanding.data.direccion },
      ],
      razonSocial: this.esPersonaNaturalDemandante
        ? undefined
        : this.formDemanding.data.primerNombre,
      datosRepresentanteLegal: !this.esPersonaNaturalDemandante
        ? representante
        : undefined,
    };

    const apoderado: PersonaDto = {
      id: this.idApoderado ? this.idApoderado : null,
      idTipoPersona: Number(this.formRepresentative.data.tipoDePersona),
      correoElectronico: this.formRepresentative.data.email,
      primerNombre: this.formRepresentative.data.primerNombre,
      segundoNombre: this.formRepresentative.data.segundoNombre,
      primerApellido: this.formRepresentative.data.primerApellido,
      segundoApellido: this.formRepresentative.data.segundoApellido,
      idTipoIdentificacion: Number(this.formRepresentative.data.tipoDocumento),
      identificacion: this.formRepresentative.data.identificacion,
      municipio: { id: Number(this.formRepresentative.data.municipio) },
      otroDepartamento: this.formRepresentative.data.otroDepartamento,
      otroMunicipio: this.formRepresentative.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formRepresentative.data.direccion },
      ],
      tarjetaProfesional:
        this.expediente.controls['numeroTarjetaProfesional'].value,
      telefonoPrincipal: this.expediente.controls['telefonoApoderado'].value,
    };

    const demandado: PersonaDto = {
      id: this.idDemandado ? this.idDemandado : null,
      idTipoPersona: Number(this.formDefendant.data.tipoDePersona),
      correoElectronico: this.formDefendant.data.email,
      primerNombre: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.primerNombre
        : undefined,
      segundoNombre: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.segundoNombre
        : undefined,
      primerApellido: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.primerApellido
        : undefined,
      segundoApellido: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.segundoApellido
        : undefined,
      idTipoIdentificacion: Number(this.formDefendant.data.tipoDocumento),
      identificacion: this.formDefendant.data.identificacion,
      municipio: {
        id:
          +this.formDefendant.data.pais == Constants.ID_COLOMBIA
            ? Number(this.formDefendant.data.municipio)
            : await this.getMunicipioCountrie(+this.formDefendant.data.pais),
      },
      otroDepartamento: this.formDefendant.data.otroDepartamento,
      otroMunicipio: this.formDefendant.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formDefendant.data.direccion },
      ],
      razonSocial: this.formDefendant.data.primerNombre
        ? this.formDefendant.data.primerNombre
        : undefined,
    };

    const tramite: TramiteDndaDto = {
      id: this.idTramite ? this.idTramite : null,
      claseSolicitud: { id: this.claseSolicitud },
      tieneApoderado: this.actuarConApoderado,
      tipoAnexo: Number(this.expediente.get('tipoAnexo')?.value),
      demandante: [demandante],
      apoderado: this.actuarConApoderado ? apoderado : undefined,
      demandado:
        this.claseSolicitud == this.demandId &&
          this.formDefendant.data.tipoDePersona
          ? [demandado]
          : undefined,
      usuario: {
        id: this.dataUsuario?.idUsuario ? this.dataUsuario?.idUsuario : id,
      },
      idioma: this.idiomaActual,
    };
    formData.append('enviar', 'true');
    formData.append(
      'enviarCorreoDemandado',
      String(this.enviarCorreoDemandado ?? false)
    );
    formData.append('tramite', JSON.stringify(tramite));
    this.loadFilesToFormData(this.expediente.value, formData);

    this.tramiteDndaService.postCrearTramiteDnda(formData).subscribe(() => {
      const mensajeConEntidad = this.alertaText['dnda-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad);

      this.alertaModalService.exito(
        this.alertaText['expediente-creado'],
        mensajeConEntidad
      );

      this.router.navigate(['/expediente']);
    });
  }

  markFormsAsTouched() {

    // Marcar todos los <app-persona>
    if (this.personaComponentes && this.personaComponentes.length > 0) {
      this.personaComponentes.forEach((comp: PersonaComponent) => {
        comp.marcarTodoComoTocado();
      });
    }

    if (this.expediente.get('telefonoApoderado')) {
      this.expediente.get('telefonoApoderado')?.markAllAsTouched();
      this.expediente.get('numeroTarjetaProfesional')?.markAllAsTouched();
    }

    // Marcar expediente (proceeding) completo
    this.expediente.markAllAsTouched();
  }

  addPersonToFormData(
    formData: FormData,
    person: PersonaDTO,
    personType: string
  ): FormData {
    for (const key in person) {
      if (Object.prototype.hasOwnProperty.call(person, key)) {
        formData.append(`${personType}[${key}]`, person[key]);
      }
    }
    return formData;
  }

  loadFilesToFormData(formValue: any, formData: FormData): FormData {
    if (!this.idTramite && formValue.archivos) {
      Array.from(formValue.archivos as FileList).forEach(
        (file: File) => formData.append('archivos', file)
      );
    } else if (formValue.archivos && formValue.archivos) {
      const archivosNuevos = Array.from(formValue.archivos as FileList);
      const archivosAntiguos = this.archivosCargados || [];

      archivosNuevos.forEach(archivoNuevo => {

        // Buscar si ya existe en los cargados
        const esElMismoArchivo = archivosAntiguos.some(archivoAntiguo =>
          archivoAntiguo.nombreArchivo === archivoNuevo.name &&
          +archivoAntiguo.tamano === archivoNuevo.size
        );

        // Si NO existe → agregarlo al formData
        if (!esElMismoArchivo) {
          formData.append('archivos', archivoNuevo);
        }
      });
    }
    return formData;
  }

  async onSubmitSave(): Promise<{ success: boolean; message?: string }> {
    let id = 0;
    if (this.dataUsuario === undefined) {
      id = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      ).idUsuario;
    }
    const representante: PersonaDto = {
      id: this.idRepresentante ? this.idRepresentante : null,
      idTipoPersona: Number(this.formRepresentanteLegal.data.tipoDePersona),
      correoElectronico: this.formRepresentanteLegal.data.email,
      primerNombre: this.formRepresentanteLegal.data.primerNombre,
      segundoNombre: this.formRepresentanteLegal.data.segundoNombre,
      primerApellido: this.formRepresentanteLegal.data.primerApellido,
      segundoApellido: this.formRepresentanteLegal.data.segundoApellido,
      idTipoIdentificacion: Number(
        this.formRepresentanteLegal.data.tipoDocumento
      ),
      identificacion: this.formRepresentanteLegal.data.identificacion,
      municipio: {
        id: Number(this.formRepresentanteLegal.data.municipio),
        idPais: +this.formRepresentanteLegal.data.pais,
        idDepartamento: +this.formRepresentanteLegal.data.departmento
      },
      otroDepartamento: this.formRepresentanteLegal.data.otroDepartamento,
      otroMunicipio: this.formRepresentanteLegal.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formRepresentanteLegal.data.direccion },
      ],
      razonSocial: this.formRepresentanteLegal.data.primerNombre,
    };

    const municipioDemandante: any = {};
    if (this.formDemanding.data['pais']) {
      municipioDemandante.idPais = this.formDemanding.data['pais'];
    }
    if (this.formDemanding.data['departmento']) {
      municipioDemandante.idDepartamento = this.formDemanding.data['departmento'];
    }
    if (this.formDemanding.data['municipio']) {
      municipioDemandante.id = this.formDemanding.data['municipio'];
    }
    const demandante: PersonaDto = {
      id: this.idDemandante ? this.idDemandante : null,
      idTipoPersona: Number(this.formDemanding.data.tipoDePersona),
      correoElectronico: this.formDemanding.data.email,
      primerNombre: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.primerNombre
        : undefined,
      segundoNombre: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.segundoNombre
        : undefined,
      primerApellido: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.primerApellido
        : undefined,
      segundoApellido: this.esPersonaNaturalDemandante
        ? this.formDemanding.data.segundoApellido
        : undefined,
      idTipoIdentificacion: Number(this.formDemanding.data.tipoDocumento),
      identificacion: this.formDemanding.data.identificacion,
      municipio: Object.keys(municipioDemandante).length > 0 ? municipioDemandante : undefined,
      otroDepartamento: this.formDemanding.data.otroDepartamento,
      otroMunicipio: this.formDemanding.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formDemanding.data.direccion },
      ],
      razonSocial: this.esPersonaNaturalDemandante
        ? undefined
        : this.formDemanding.data.primerNombre,
      datosRepresentanteLegal: !this.esPersonaNaturalDemandante
        ? representante
        : undefined,
    };
    let municipioApoderado: any = {};
    if (this.formRepresentative.data['municipio']) {
      municipioApoderado.id = this.formRepresentative.data['municipio'];
    }
    if (this.formRepresentative.data['pais']) {
      municipioApoderado.idPais = this.formRepresentative.data['pais'];
    }
    if (this.formRepresentative.data['departmento']) {
      municipioApoderado.idDepartamento = this.formRepresentative.data['departmento'];
    }

    const apoderado: PersonaDto = {
      id: this.idApoderado ? this.idApoderado : null,
      idTipoPersona: Number(this.formRepresentative.data.tipoDePersona),
      correoElectronico: this.formRepresentative.data.email,
      primerNombre: this.formRepresentative.data.primerNombre,
      segundoNombre: this.formRepresentative.data.segundoNombre,
      primerApellido: this.formRepresentative.data.primerApellido,
      segundoApellido: this.formRepresentative.data.segundoApellido,
      idTipoIdentificacion: Number(this.formRepresentative.data.tipoDocumento),
      identificacion: this.formRepresentative.data.identificacion,
      municipio: Object.keys(municipioApoderado).length > 0 ? municipioApoderado : undefined,
      otroDepartamento: this.formRepresentative.data.otroDepartamento,
      otroMunicipio: this.formRepresentative.data.otroMunicipio,
      direccionPersona: [
        { direccionNotificacion: this.formRepresentative.data.direccion },
      ],
      tarjetaProfesional:
        this.expediente.controls['numeroTarjetaProfesional'].value,
      telefonoPrincipal: this.expediente.controls['telefonoApoderado'].value,
    };

    const demandado: PersonaDto = {
      id: this.idDemandado ? this.idDemandado : null,
      idTipoPersona: this.formDefendant.data.tipoDePersona
        ? Number(this.formDefendant.data.tipoDePersona)
        : undefined,
      correoElectronico: this.formDefendant.data.email
        ? this.formDefendant.data.email
        : undefined,
      primerNombre: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.primerNombre
        : undefined,
      segundoNombre: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.segundoNombre
        : undefined,
      primerApellido: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.primerApellido
        : undefined,
      segundoApellido: this.formDefendant.data.tipoDePersona
        ? this.formDefendant.data.segundoApellido
        : undefined,
      idTipoIdentificacion: this.formDefendant.data.tipoDocumento
        ? Number(this.formDefendant.data.tipoDocumento)
        : undefined,
      identificacion: this.formDefendant.data.identificacion
        ? this.formDefendant.data.identificacion
        : undefined,
      municipio:
        this.formDefendant.data.pais || this.formDefendant.data.municipio
          ? {
            id:
              +this.formDefendant.data.pais == Constants.ID_COLOMBIA
                ? Number(this.formDefendant.data.municipio)
                : await this.getMunicipioCountrie(
                  +this.formDefendant.data.pais
                ),
          }
          : undefined,
      otroDepartamento: this.formDefendant.data.otroDepartamento
        ? this.formDefendant.data.otroDepartamento
        : undefined,
      otroMunicipio: this.formDefendant.data.otroMunicipio
        ? this.formDefendant.data.otroMunicipio
        : undefined,
      direccionPersona: this.formDefendant.data.direccion
        ? [{ direccionNotificacion: this.formDefendant.data.direccion }]
        : undefined,
      razonSocial: this.formDefendant.data.primerNombre
        ? this.formDefendant.data.primerNombre
        : undefined,
    };
    const tramite: TramiteDndaDto = {
      id: this.idTramite ? this.idTramite : null,
      claseSolicitud: { id: this.claseSolicitud },
      tieneApoderado: this.actuarConApoderado,
      tipoAnexo: Number(this.expediente.get('tipoAnexo')?.value),
      demandante: [demandante],
      apoderado: this.actuarConApoderado ? apoderado : undefined,
      demandado:
        this.claseSolicitud == this.demandId &&
          this.formDefendant.data.tipoDePersona
          ? [demandado]
          : [],
      usuario: {
        id: this.dataUsuario?.idUsuario ? this.dataUsuario?.idUsuario : id,
      },
      idioma: this.idiomaActual,
    };
    const formData: FormData = new FormData();

    formData.append('enviar', 'false');
    formData.append('tramite', JSON.stringify(tramite));
    this.loadFilesToFormData(this.expediente.value, formData);
    try {
      const response = await firstValueFrom(
        this.tramiteDndaService.postCrearTramiteDnda(formData)
      );
      if (response.success) {
        const mensajePersonalizado = this.alertaText['dnda-alertas']['tramite-enviado-mensaje']
          .replace('{{entidad}}', this.entidad)
          .replace('{{proceso}}', this.proceso);
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          mensajePersonalizado
        );
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false, message: 'Error al guardar' };
    }
    // this.tramiteDndaService
    //   .postCrearTramiteDnda(formData)
    //   .subscribe(response => {
    //     this.tramite = response.data;
    //     this.alertaModalService.exito(this.alertaText['proceso-guardado-exitosamente']);
    //   });
  }

  setUpdateData(formData: FormData, enviar = false): void {
    const tramiteData = this.tramite?.data;
    if (!tramiteData) {
      return;
    }

    const tramiteFields = {
      idTramite: tramiteData.Id,
      idDemandantePersonaNatural: tramiteData.idDemandantePersonaNatural,
      idDemandantePersonaJuridica: tramiteData.idDemandantePersonaJuridica,
    };

    Object.entries(tramiteFields).forEach(([key, value]) => {
      if (value && !formData.has(key)) {
        formData.append(key, value);
      }
    });

    if (enviar && !formData.has('enviar')) {
      formData.append('enviar', 'true');
    }
  }

  getDataUsuario(idPersona: number) {
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        if (response.datoAdicionalAbogado) {
          this.expediente
            .get('numeroTarjetaProfesional')
            ?.setValue(response.datoAdicionalAbogado.Tarjeta_Profesional);
        }
      });
  }

  onCheckboxChange(event: Event): void {
    this.confirmacionEnvio = (event.target as HTMLInputElement).checked;
  }

  get correoDemandado(): string {
    return this.demandadoAux?.email ?? '';
  }

  get nombreDemandado(): string {
    const d = this.demandadoAux;
    return `${d.primerNombre ?? ''} ${d.segundoNombre ?? ''} ${d.primerApellido ?? ''} ${d.segundoApellido ?? ''}`.trim();
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }
}
